// extracted by mini-css-extract-plugin
module.exports = {"analyticsCardContainer":"AnalyticsCard_analyticsCardContainer__2FhSm","titleContainer":"AnalyticsCard_titleContainer__OWSQa","title":"AnalyticsCard_title__2wKYl"};